import { v1 as uuidv1 } from "uuid";

// Function to generate a UUID v1 (similar to "312ad654-306a-11f0-a203-0291eb85ff87")
export function generateUUIDv1(): string {
  return uuidv1();
}

// Example usage:
// const newId = generateUUIDv1();
// console.log(newId);
